import React from "react";

const useGeoLocation = () => {
  const [location, setLocation] = React.useState({
    loaded: false,
    coordinates: { latitude: "", longitude: "" },
  });

  const onSuccess = location => {
    setLocation({
      loaded: true,
      coordinates: {
        latitude: location.coords.latitude.toFixed(10),
        longitude: location.coords.longitude.toFixed(10),
      },
    });
  };

  const setError = error => {
    setLocation({
      loaded: true,
      error: {
        code: error.code,
        message: error.message,
      },
    });
  };

  const onError = error => {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        setError({
          code: error.code,
          message: "User denied the request for Geolocation.",
        });
        break;
      case error.POSITION_UNAVAILABLE:
        setError({
          code: error.code,
          message: "Location information is unavailable.",
        });
        break;
      case error.TIMEOUT:
        setError({
          code: error.code,
          message: "The request to get user location timed out",
        });
        break;
      case error.UNKNOWN_ERROR:
        setError({
          code: error.code,
          message: "An unknown error occurred.",
        });
        break;
      default:
        setError({
          code: 0,
          message: "An unknown error occurred.",
        });
    }
  };

  React.useEffect(() => {
    if (!("geolocation" in navigator)) {
      onError({
        code: 0,
        message: "Geolocation not supported",
      });
    }

    navigator.geolocation.getCurrentPosition(onSuccess, onError, {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    });

    return () =>
      setLocation({
        loaded: false,
        coordinates: { latitude: "", longitude: "" },
      });
    // eslint-disable-next-line
  }, []);

  return location;
};

export default useGeoLocation;
